module.exports = __webpack_public_path__ + "img/horizontal_2_1_7042.2e86a173.png";